import styled from 'styled-components'

export const FallbackLoadingStyle = styled.div`
  .container_ {
     position: absolute;
    display: flex;
    flex-direction: column;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    z-index: 99999;
  }

  .loading_img {
    width: 300px;
  }

  .section-wrap {
    width: 300px;
  }
  .loader-wrap {
    position: relative;
    padding: 20px 20px 100px 20px;
  }
  .loader {
    position: relative;
    border: 1px solid rgba(150, 167, 181, 0.2);
  }
  .loader:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    height: 1px;
    background-color: #fff;
    -webkit-animation: loading 1.3s ease-in-out 0s infinite;
    animation: loading 1.3s ease-in-out 0s infinite;
  }
  @-webkit-keyframes loading {
    0% {
      -webkit-transform: scaleX(0);
      transform: scaleX(0);
    }
    100% {
      -webkit-transform: scaleX(1);
      transform: scaleX(1);
    }
  }
  @keyframes loading {
    0% {
      -webkit-transform: scaleX(0);
      transform: scaleX(0);
    }
    100% {
      -webkit-transform: scaleX(1);
      transform: scaleX(1);
    }
  }
`
